<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="loading" />
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
           <v-checkbox v-model="parameterValue" @click.native.prevent.stop.capture="callInformModal">
          <template slot="label">
            <template>{{
              'Patvirtinu, kad visos paslaugos / veiksmai yra susietos su NIRVAR sritimis'
            }}</template>
          </template>
        </v-checkbox>
      </v-card-title>
    </v-card>
      <!-- modals -->
    <modal-custom
      :title="getModalText"
      :text="getText"
      trueText="Taip"
      falseText="Atšaukti"
      :loading="loading"
      mid
      v-model="showInformModal"
      @confirmData="confirmAction"
    />
  </v-container>
</template>

<script>
import ModalCustom from '@/components/modals/ModalCustom'

export default {
  name: 'ActionMapped',
  components: { ModalCustom },
  data: () => ({
    loading: false,
    loadDefault: null,
    parameterValue: false,
    showInformModal: false,
  }),
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getParameter()
  },
  computed: {
    getModalText(){
      if(this.parameterValue){
        return this.$t('Ar tikrai norite nuimti patvirtinimą?')
      }
      return this.$t('Patvirtinu, kad visos paslaugos / veiksmai yra susietos su NIRVAR sritimis')
    },
    getText(){
      if(this.parameterValue){
        return  this.$t('')
      }
      return this.$t('Ar tikrai visos paslaugos / veiksmai yra susietos su NIRVAR sritimis?')
    }
  }, 
  methods: {
    callInformModal() {
      this.showInformModal = true
    },
    getParameter() {
      this.loading = true
      let url = `services-mapped`
      this.$axios
        .get(url)
        .then((res) => {
          this.parameterValue = res.data.nirvar_mapped
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmAction() {
      this.saveParameter()
    },
    saveParameter() {
      this.loading = true
      let url = `services-mapped`      
      this.$axios
        .post(url, {parameter_value: this.parameterValue ? 0 : 1})
        .then((res) => {
          this.$root.$emit('DATA_OK', 'Išsaugota')
          this.parameterValue = !this.parameterValue
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.showInformModal = false
          this.loading = false
        })
    },
  },
}
</script>
